/**
 * Get the theme state
 * @category Core
 */
export const gridIsRtlSelector = state => state.isRtl;